import React from "react";

function DashboardPage () {
  return (
    <div>Dashboard Page</div>
)
};
export default DashboardPage;